var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'TakeFilter',
        name: 'take'
      },
      {
        type: 'WhereFilter',
        label: 'ID',
        attributes: 'id'
      },
      {
        type: 'WhereLikeFilter',
        label: 'E-Mail-Adresse',
        attributes: 'user.email'
      },
      {
        type: 'WhereLikeFilter',
        label: 'Name',
        attributes: 'name'
      },
      {
        type: 'DateFilter',
        label: 'Registrierdatum von',
        attributes: { column: 'created_at', operator: '>=' }
      },
      {
        type: 'DateFilter',
        label: 'Registrierdatum bis',
        attributes: { column: 'created_at', operator: '<=' }
      },
      {
        type: 'CheckboxFilter',
        label: 'Mögliche Dublicate',
        name: 'display_dublicates'
      }
    ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-table',{staticClass:"customer-list-table",attrs:{"url":"/api/v1/customerProfile","filter":_vm.filter,"appends":[
      'user.registered_with_ip_and_country',
      'total_revenu',
      'ins_outs',
      'balance',
      'last_login_at',
      'last_seen_at',
      'last_seen_on'
    ],"row-classes":{
      'table-disabled': model => {
        return Boolean(model.user.disabled_at);
      },
      'table-deleted': model => {
        return Boolean(model.deleted_at);
      },
      'table-deletion': model => {
        return Boolean(model.user.deletion_at);
      }
    },"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'name',
        type: 'LinkProfileCell',
        name: 'Mitglied'
      },
      {
        attribute: 'user.email',
        name: 'E-Mail-Adresse',
        sortable: false
      },
      {
        attribute: 'country',
        name: 'Herkunft',
        type: 'CustomerOriginAndIpCell',
        sortable: false
      },
      {
        attribute: 'created_at',
        name: 'Registert am',
        type: 'DateTimeCell'
      },
      {
        name: 'Online',
        type: 'OnlineVerifiedCell'
      },
      {
        html: true,
        name: _vm.euro,
        centered: true,
        attribute: 'total_revenu',
        type: 'CurrencyCell',
        sortable: false
      },
      {
        html: true,
        name: _vm.balance,
        centered: true,
        attribute: 'balance',
        type: 'BalanceCell',
        sortable: false
      },
      {
        name: 'In/Out',
        type: 'CustomerInOutCell',
        sortable: false
      },
      {
        attribute: 'last_seen_at',
        name: 'Letzte Seite',
        type: 'LastPageCell'
      },
      {
        name: 'Aktionen',
        type: 'CustomerActionCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }